<template>
    <DModal
        :show="showModal"
        :title="__('tools.php_eol.batches.create_batch_form.title')"
        :message="__('tools.php_eol.batches.create_batch_form.message')"
        @close="$emit('close-modal')"
        @confirm="submitForm"
    >
        <template #default>
            <DCard
                padding
            >
                <DFormRow
                    :label="__('tools.php_eol.batches.create_batch_form.number_of_contracts')"
                    is-required
                    :error="errorsData.number_of_contracts"
                >
                    <DInput
                        id="number_of_contracts"
                        v-model="form.number_of_contracts"
                        :is-valid="isFormFieldValid('number_of_contracts')"
                        type="number"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('tools.php_eol.batches.create_batch_form.force_json_download')"
                    is-required
                    :error="errorsData.force_json_download"
                >
                    <DSwitch
                        id="force_json_download"
                        v-model="form.force_json_download"
                        color="success"
                        variant="3d"
                        :disabled="isInLoadingState"
                    />
                </DFormRow>
                <DFormRow
                    :label="__('tools.php_eol.batches.create_batch_form.process_specific_php_version')"
                >
                    <DSwitch
                        id="php_version_switch"
                        v-model="processSpecificVersion"
                        color="success"
                        variant="3d"
                    />
                </DFormRow>
                <DFormRow
                    v-if="processSpecificVersion"
                    :label="__('tools.php_eol.batches.create_batch_form.php_version')"
                    :error="errorsData.php_version"
                >
                    <DSelect
                        id="php_version"
                        v-model="form.php_version"
                        :options="stagedPhpVersionOptions"
                        :is-valid="isFormFieldValid('php_version')"
                    />
                </DFormRow>
            </DCard>
        </template>
    </DModal>
</template>

<script setup>

import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'
import { computed, ref, watch } from 'vue'

const props = defineProps({
    errors: {
        type: Object,
        default: () => { return {} }
    },
    showModal: {
        type: Boolean,
        default: false
    },
    activeModule: {
        type: String,
        default () {
            return ''
        }
    },
    stagedPhpVersions: {
        type: Array,
        default () {
            return []
        }
    }
})

const errorsData = ref(props.errors)
const processSpecificVersion = ref(false)

watch(processSpecificVersion, (enabled) => {
    if (!enabled) {
        form.php_version = null
    }
})

const stagedPhpVersionOptions = computed(() =>
    props.stagedPhpVersions.map(v => ({ label: v, value: v }))
)

const form = useForm({
    number_of_contracts: null,
    force_json_download: false,
    php_version: null,
    module: props.activeModule
})

const emit = defineEmits(['close-modal', 'form-submitted'])

const submitForm = () => {
    form.post(route('contracts.php-eol-bulk.store'), {
        onSuccess: () => {
            emit('form-submitted')
            emit('close-modal')
        },
        onError: (error) => {
            errorsData.value = error
        },
        onFinish: () => {
            form.number_of_contracts = null
            form.force_json_download = false
        }
    })
}
</script>
